// Types
import { AppDispatch, AppGetState } from 'types/RootState.types';
import { FeatureFlagType } from 'types/FeatureFlag.types';

// Config
import userConstants from '../../../constants/userConstants';
import featureConstants from '../../../constants/featureConstants';
import { isFeatureActive } from '../../reducers/config/configReducer';
import { recordImpressions } from '../app/appActions';
import isClickAndCollectAvailable from '../../../utils/collection/isClickAndCollectAvailable';

type DeliveryPageResponseType = {
  result?: {
    customer?: {
      preferences?: {
        fulfilmentChoice?: string;
      };
    };
    orderForm?: {
      deliveryOptions?: {};
    };
  };
};

export const recordPreferredDeliveryChoiceImpression = () => (
  dispatch: AppDispatch,
  getState: AppGetState,
) => {
  const {
    config: {
      features = [],
    } = {},
  } = getState() ?? {};

  const preferredDeliveryChoiceEnabledFeature = features?.find(
    (feature: FeatureFlagType) => feature.id === featureConstants.PREFERRED_DELIVERY_CHOICE,
  ) ?? {} as FeatureFlagType;

  const preferredDeliveryChoiceEnabledFeatureImpressionId = preferredDeliveryChoiceEnabledFeature.impressionId;
  if (preferredDeliveryChoiceEnabledFeatureImpressionId) {
    dispatch(recordImpressions(preferredDeliveryChoiceEnabledFeatureImpressionId));
  }
};

export const shouldSetPreferredDeliveryChoice = (
  deliveryPageResponse: DeliveryPageResponseType,
) => (dispatch: AppDispatch, getState: AppGetState) => {
  const {
    result: {
      customer: {
        preferences: {
          fulfilmentChoice = '',
        } = {},
      } = {},
      orderForm: {
        deliveryOptions = {},
      } = {},
    } = {},
  } = deliveryPageResponse ?? {};

  const fulfilmentChoiceIsDelivery = fulfilmentChoice === userConstants.FULFILMENT_PREFERENCE_DELIVERY;

  if (
    fulfilmentChoiceIsDelivery &&
    isClickAndCollectAvailable(deliveryOptions)
  ) dispatch(recordPreferredDeliveryChoiceImpression());

  const preferredDeliveryChoiceEnabled = isFeatureActive(getState(), featureConstants.PREFERRED_DELIVERY_CHOICE);

  return preferredDeliveryChoiceEnabled && fulfilmentChoiceIsDelivery;
};
